import { treeCmType, treeSize, treeType } from "./types";

const colours: Record<string, any> = {
  white: "#ffffff",
  black: "#000000",
  offWhite: "#F2F2F2",
  lightGrey: "#e8e8e8",
  grey1: "#6F6F6F",
  grey2: "#9c9c9c",
  grey3: "#c7c7c7",
  darkGrey: "#3d3d3d",
  darkerGrey: "#242424",

  // Theme colours
  th1: "#201547",
  th2: "#03B6BD",
  th3: "#CFDD00",

  // Theme 1 variations
  th1l1: "#5A5275",
  th1l2: "#76708e",
  th1l3: "#BCB7C7",
  th1l4: "#DFDAE7",
  th1l5: "#ECE9F1",

  th1l1alt: "rgba(32, 21, 71, 0.7)", // subheader brand color
  th1l3alt: "#aa98dc",

  // Theme 2 variations
  th2d1: "#009EA4",
  th2l1: "#DDF9F9",
  th2alt: "#2cc4c9", // background color contrasting with th1

  // Theme 3 variations
  th3l1: "#FAFDD8",

  // Badges
  [treeCmType.DBH]: "#e3bfe3",
  [treeCmType.CIR]: "#ecde79",
  [treeSize.Sm]: "#d7ec93",
  [treeSize.Lg]: "#8ede78",

  // Map (transparent colours needs to be in rgba format)
  patchOutline: "#8b4dd5",
  revegetationAreaOutline: "#8b4dd5",
  scatteredBufferOutline: "#df5885",
  patchFill: "rgba(223, 218, 231, 0.5)",
  revegetationAreaFill: "rgba(223, 218, 231, 0.5)",
  scatteredBufferFill: "rgba(231, 218, 222, 0.5)",
  [treeType.Patch]: "#8b4dd5",
  [treeType.Scattered]: "#df5885",
  treeLabels: {
    [treeType.Patch]: "#201547",
    [treeType.Scattered]: "#9b0336",
  },

  // Summary tags
  basicPathway: "#F8DDF1",
  intermediatePathway: "#F2B6E0",
  detailedPathway: "#D539A6",
  basicPathwayText: "#5A5275",
  intermediatePathwayText: "#201547",
  detailedPathwayText: "#ffffff",
  location1: "#bce6de",
  location2: "#5bc2b3",
  location3: "#d59d62",
  location1Text: "#5A5275",
  location2Text: "#201547",
  location3Text: "#1a1a1a",

  // Summary table
  summaryHeader: "#dfdde4",

  // Other
  error: "#d95e68",
  errord1: "#AF272F",
  errorl1: "#FBEEEF",
  flag: "#E2DB22",
  flagl1: "#F9F7B8",
};

export default colours;
